import {StructuredTableColumn} from 'notebook/structured-tables/StructuredTableConstants';
import {Cell, FromServerCell} from 'notebook/tables/constants/CellConstants';
import Excess from 'notebook/tables/excess';

function hasText(cell: FromServerCell): cell is Cell {
  return cell.text != null;
}

/**
 * Converts a server-provided table cell to a client cell, writing the column default formula for the cell's
 * position when the server stored it without text (see `FromServerCell`).
 *
 * See benchling.notebook.tables.write_cell:make_structured_table_cell
 *
 * @param cell Cell being converted.
 * @param columns Columns that specify default values.
 * @param i Row index.
 * @param j Column index.
 */
export default function fillFormulaDefault(
  cell: FromServerCell,
  columns: ReadonlyArray<Pick<StructuredTableColumn, 'defaultValue'>>,
  i: number,
  j: number
): Cell {
  if (hasText(cell)) {
    return cell;
  }
  const rel = Excess.tokenizer.toRelativeFormula(columns[j].defaultValue.text, {row: 0, column: j});
  const abs = Excess.tokenizer.toAbsoluteFormula(rel, {row: i, column: j});
  return {...cell, text: abs};
}
